import { Button } from 'devextreme-react';
import React from 'react';
import useSWR from 'swr';
import { Loader } from '../../../components/loader/Loader';
import { useTranslation } from '../../../contexts/translation';
import { ParameterMeasurable } from '../../../types/parameter.types';
import { API_URL, fetcher } from '../../../utils/apiUrl';

interface Props {
  assetId: number;
  onSelectParameter: (assetParameterId: number) => void;
}

export const ParametersMeasuringButtons = ({ assetId, onSelectParameter }: Props) => {
  const transFormName = 'ParameterMeasuredMobile.Page';
  const { translate } = useTranslation();

  const { data: parameters, isValidating: parametersValidating } = useSWR<ParameterMeasurable[]>(
    `${API_URL.ASSET_PARAMETER_MEASURABLE_LIST}?parentId=${assetId}`,
    fetcher,
  );

  const handleOnClick = (assetParameterId: number) => {
    onSelectParameter(assetParameterId);
  };

  if (parametersValidating) return <Loader />;
  if (parameters && parameters.length === 0)
    return (
      <div style={{ padding: 15, textAlign: `center`, marginTop: 30, fontSize: 22 }}>
        {translate!('No parameters', transFormName)}
      </div>
    );

  return (
    <div style={{ padding: 15, marginTop: 15 }}>
      {parameters?.map((parameter: ParameterMeasurable) => {
        return (
          <Button
            key={parameter.parameterId}
            text={`${parameter.parameterName} (${parameter.unitName})`}
            type={'normal'}
            stylingMode={'contained'}
            width={'100%'}
            style={{ fontSize: 24, marginBottom: 15, padding: 15 }}
            onClick={() => handleOnClick(parameter.id)}
          />
        );
      })}
    </div>
  );
};
